var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"prefix__a","d":"M6.476 12L2.667 8.161 3.741 7.079 6.476 9.827 12.259 4 13.333 5.09z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M0 0L15.61 0 15.61 15.61 0 15.61z","key":0}),React.createElement("mask",{"id":"prefix__b","fill":"#fff","key":1},React.createElement("use",{"xlinkHref":"#prefix__a"})),React.createElement("use",{"fill":"#005CF7","xlinkHref":"#prefix__a","key":2}),React.createElement("g",{"fill":"#005CF7","mask":"url(#prefix__b)","key":3},React.createElement("path",{"d":"M0 0H16V16H0z"}))])]);
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Check;

Check.default = Check;
